import React, { useId } from "react";

interface MonocoinIconProps {
	width?: number | string;
	height?: number | string;
	className?: string;
	style?: React.CSSProperties;
}

const MonocoinIcon: React.FC<MonocoinIconProps> = ({
	width = 24,
	height = 24,
	className,
	style,
}) => {
	const clipId = useId();
	const clipOuter = `${clipId}-outer`;
	const clipInner = `${clipId}-inner`;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={style}
		>
			<g clipPath={`url(#${clipOuter})`}>
				<path
					d="M12 24C5.38345 24 0 18.6165 0 12C0 5.38345 5.38345 0 12 0C18.6165 0 24 5.38345 24 12C24 18.6165 18.6165 24 12 24Z"
					fill="#F0C419"
				/>
				<path
					d="M21.931 11.9994C21.931 6.51455 17.4848 2.06836 12 2.06836C6.51516 2.06836 2.06897 6.51455 2.06897 11.9994C2.06897 17.4842 6.51516 21.9304 12 21.9304C17.4848 21.9304 21.931 17.4842 21.931 11.9994Z"
					fill="#B5901A"
				/>
				<path
					d="M19.4483 11.9991C19.4483 7.88556 16.1135 4.55078 12 4.55078C7.88648 4.55078 4.5517 7.88556 4.5517 11.9991C4.5517 16.1126 7.88648 19.4474 12 19.4474C16.1135 19.4474 19.4483 16.1126 19.4483 11.9991Z"
					fill="#F0C419"
				/>
				<path
					d="M12 0C11.861 0 11.724 0.0058125 11.5862 0.0103594V2.06897C11.5862 2.29781 11.7712 2.48278 12 2.48278C12.2288 2.48278 12.4138 2.29781 12.4138 2.06897V0.0103594C12.276 0.0058125 12.139 0 12 0Z"
					fill="#B5901A"
				/>
				<path
					d="M20.1817 3.23242L18.7421 4.672C18.5803 4.83381 18.5803 5.0957 18.7421 5.25752C18.8228 5.33819 18.9287 5.37873 19.0347 5.37873C19.1402 5.37873 19.2461 5.33819 19.3272 5.25752L20.7668 3.81752C20.5785 3.61605 20.3832 3.42072 20.1817 3.23242Z"
					fill="#B5901A"
				/>
				<path
					d="M21.5172 11.9998C21.5172 12.2286 21.7022 12.4136 21.931 12.4136H23.9896C23.9942 12.2758 24 12.1384 24 11.9998C24 11.8611 23.9942 11.7238 23.9896 11.5859H21.931C21.7022 11.5859 21.5172 11.7709 21.5172 11.9998Z"
					fill="#B5901A"
				/>
				<path
					d="M19.327 18.7425C19.1652 18.5806 18.9037 18.5806 18.7419 18.7425C18.5802 18.9043 18.5801 19.1658 18.7419 19.3275L20.1815 20.7675C20.3835 20.5789 20.5784 20.384 20.7666 20.182L19.327 18.7425Z"
					fill="#B5901A"
				/>
				<path
					d="M12 21.5176C11.7712 21.5176 11.5862 21.7025 11.5862 21.9314V23.99C11.724 23.9945 11.861 24.0004 12 24.0004C12.139 24.0004 12.276 23.9945 12.4138 23.99V21.9314C12.4138 21.7025 12.2288 21.5176 12 21.5176Z"
					fill="#B5901A"
				/>
				<path
					d="M4.67298 18.7424L3.2334 20.182C3.4217 20.384 3.61655 20.5789 3.81849 20.7675L5.25807 19.3275C5.41988 19.1657 5.41988 18.9042 5.25807 18.7424C5.09626 18.5807 4.83479 18.5806 4.67298 18.7424Z"
					fill="#B5901A"
				/>
				<path
					d="M0.010512 12.4136H2.06912C2.29754 12.4136 2.48293 12.2286 2.48293 11.9998C2.48293 11.7709 2.29754 11.5859 2.06912 11.5859H0.010512C0.00554321 11.7238 0.000152588 11.8611 0.000152588 11.9998C0.000199463 12.1384 0.00554321 12.2758 0.010512 12.4136Z"
					fill="#B5901A"
				/>
				<path
					d="M3.23315 3.81752L4.67273 5.25709C4.75383 5.33819 4.85976 5.37831 4.9657 5.37831C5.07122 5.37831 5.17715 5.33819 5.25825 5.25709C5.41964 5.0957 5.41964 4.83377 5.25825 4.672L3.81825 3.23242C3.61678 3.42067 3.42145 3.616 3.23315 3.81752Z"
					fill="#B5901A"
				/>
				<g clipPath={`url(#${clipInner})`}>
					<path
						d="M17.1525 11.4631C16.8675 11.4744 16.5787 11.4331 16.2937 11.4106C16.0462 11.3919 15.7987 11.3956 15.555 11.3581L13.9237 9.71563L13.2037 8.99188C12.9375 8.72938 12.6525 8.45938 12.39 8.19313C12.3487 8.15188 12.3037 8.11063 12.2475 8.05063C12.1575 7.96063 12.075 7.93813 12.0037 7.96438C11.97 7.97563 11.94 7.99813 11.91 8.02813L8.04 11.9169C7.9725 12.0069 7.9725 12.0669 8.04 12.1569L10.6125 14.7106V13.0269L11.6437 11.9956V17.2756C11.5687 17.2119 11.5012 17.1444 11.4337 17.0769C10.1287 15.7119 8.77875 14.3844 7.455 13.0381C7.095 12.6706 6.67125 12.3931 6.8625 11.7856C6.96 11.4744 7.57125 10.9419 7.8225 10.6869C8.97375 9.50188 10.1475 8.33563 11.3137 7.16563C11.5275 6.95188 11.67 6.70438 12.0075 6.67813C12.2362 6.66313 12.3975 6.71938 12.5662 6.86563L17.1487 11.4631H17.1525Z"
						fill="#81691F"
					/>
					<path
						d="M17.1825 12.5555L12.405 17.3255C12.39 15.653 12.39 13.1555 12.39 11.2542L13.4138 10.2305L13.4063 14.7905L15.465 12.7242L17.1825 12.5592V12.5555Z"
						fill="#81691F"
					/>
				</g>
			</g>
			<defs>
				<clipPath id={clipOuter}>
					<rect width="24" height="24" fill="white" />
				</clipPath>
				<clipPath id={clipInner}>
					<rect
						width="12"
						height="12"
						fill="white"
						transform="translate(6 6)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default MonocoinIcon;
